import ChecklistItem from './checklistItem';
import { useEffect, useRef } from 'react';

const Checklist = ({ title, items, currentIndex, onExit, answerAccuracies, isComplete }) => {

    const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTo({
        top: listRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
  }, [currentIndex, isComplete]);

  return (
    <div className="checklist-area">
      <h2>{title}</h2>
     <ul ref={listRef} className="checklist-scroll">
      {items.slice(0, currentIndex + 1).map((item, itemIndex) => (
        <ChecklistItem
          key={itemIndex}
          item={item}
          correct={answerAccuracies[itemIndex]}
        />
      ))}
      {isComplete && (
      <li className="checklist-complete">
        <strong>✅ Checklist Complete!</strong>
      </li>
    )}
      <li>
        <button className="back-button" onClick={onExit}>Exit</button>
      </li>
    </ul>
    </div>
  );
};

export default Checklist;